module.exports = __webpack_public_path__ + "img/foot_course.ae320697.png";